exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".detail-title[data-v-5d67ca58]{font-size:16px;font-weight:500;color:#333}.title-margin[data-v-5d67ca58]{margin:40px 0 20px}.detail-record[data-v-5d67ca58]{padding:20px;background-color:#fff;border-radius:16px}.record-success[data-v-5d67ca58]{margin-left:20px;color:#15cd85}.record-failure[data-v-5d67ca58]{margin-left:20px;color:var(--xty-red-color)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5d67ca58&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentAIO/EquipmentAIODetail.vue
// module id = 546
// module chunks = 0